import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;

  height: 50px;
`;

const StyledParagraph = styled.p`
  color: var(--color-primary);
`;

const Footer: React.FC = () => (
  <StyledFooter>
    <StyledParagraph>
      Todos os direitos reservados &copy; Dev Seridó {new Date().getFullYear()}
    </StyledParagraph>
  </StyledFooter>
);

export default Footer;
